import {CardResult, _CardResult} from './card-result';
import {Card} from './card';
import {Curve} from './../../compute/curves/curve';
import {FitCurve} from './../../compute/computations/bivariate/fit-curve';
import {_BivariateCard} from './bivariate-card';

/**
 * Generated from com.dataiku.dip.eda.worksheets.cards.FitCurveCard
 */
export interface FitCurveCard extends _BivariateCard {
    curves: Curve[];

    // PolyJson type
    type: 'fit_curve';
}

export function isFitCurveCard(toTest: Card): toTest is FitCurveCard { return 'fit_curve' === toTest.type; }

export namespace FitCurveCard {
    /**
     * Generated from com.dataiku.dip.eda.worksheets.cards.FitCurveCard$FitCurveCardResult
     */
    export interface FitCurveCardResult extends _CardResult {
        parametrizedCurves: FitCurve.FitCurveResult[];
        xSeries: number[];
        ySeries: number[];

        // PolyJson type
        type: 'fit_curve';
    }

    export function isFitCurveCardResult(toTest: CardResult): toTest is FitCurveCardResult { return 'fit_curve' === toTest.type; }
}